module.exports = __webpack_public_path__ + "static/media/deer-rudolph.b1c15a69.svg";